<template>
  <v-row class="mt--30">
    <!-- Start Single Portfolio  -->
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      class="mt--30"
      v-for="(item, i) in portfolioContent"
      :key="i"
    >
      <div class="im_portfolio">
        <div class="thumbnail_inner">
          <div class="thumbnail">
            <router-link :to="`/projeto/${item.id}`">
              <img 
                class="w-100 portfolio-image" 
                :data-src="item.image" 
                :alt="item.title" 
                width="480"
                height="240"
                style="height: 240px;" 
                loading="lazy"
                decoding="async"
                :src="getPlaceholderImage(item.image)"
              />
            </router-link>
          </div>
        </div>
        <div class="content">
          <div class="inner">
            <div class="portfolio_heading">
              <h4 class="heading-title">
                <router-link :to="`/projeto/${item.id}`">{{
                  item.title
                }}</router-link>
              </h4>
            </div>
            <div class="portfolio_hover">
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
        <router-link
          class="transparent_link"
          :to="`/projeto/${item.id}`"
        ></router-link>
      </div>
    </v-col>
    <!-- End Single Portfolio  -->
  </v-row>
</template>

<script>
  import { getAllProjects } from "../../data/portfolioProjects";

  export default {
    data() {
      return {
        portfolioContent: getAllProjects(),
        imageObserver: null,
        loadedImages: new Set()
      };
    },
    mounted() {
      this.initLazyLoading();
    },
    beforeDestroy() {
      if (this.imageObserver) {
        this.imageObserver.disconnect();
      }
    },
    methods: {
      getPlaceholderImage(originalSrc) {
        // Retorna uma imagem placeholder base64 muito pequena
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjI0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkxvYWRpbmcuLi48L3RleHQ+PC9zdmc+';
      },
      initLazyLoading() {
        if ('IntersectionObserver' in window) {
          this.imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
                this.loadImage(img);
                observer.unobserve(img);
              }
            });
          }, {
            rootMargin: '50px 0px',
            threshold: 0.1
          });

          document.querySelectorAll('.portfolio-image').forEach(img => {
            this.imageObserver.observe(img);
          });
        } else {
          // Fallback para navegadores antigos
          document.querySelectorAll('.portfolio-image').forEach(img => {
            this.loadImage(img);
          });
        }
      },
      loadImage(img) {
        if (this.loadedImages.has(img.dataset.src)) {
          return;
        }
        
        const originalSrc = img.dataset.src;
        const tempImg = new Image();
        
        tempImg.onload = () => {
          img.src = originalSrc;
          img.classList.add('loaded');
          this.loadedImages.add(originalSrc);
        };
        
        tempImg.onerror = () => {
          console.warn('Falha ao carregar imagem:', originalSrc);
        };
        
        tempImg.src = originalSrc;
      }
    }
  };
</script>

<style scoped>
.portfolio_hover p {
  font-size: 14px;
  line-height: 1.2;
}

.portfolio-image {
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.3s ease;
  transform: scale(0.98);
}

.portfolio-image.loaded {
  opacity: 1;
  transform: scale(1);
}

.portfolio-image:hover {
  transform: scale(1.02);
}

/* Skeleton loading */
.portfolio-image:not(.loaded) {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
